module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"profileComplited":"Profile is {percent}% complete","left":"Left to complete","viewProfile":"View company profile"}}')
  delete Component.options._Ctor
}
